module.exports = __webpack_public_path__ + "static/media/cold storage1.0c689673.png";